var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ship",style:({ left: _vm.left, transition: 'left ' + _vm.transitionSpeed + 's' })},[_c('img',{staticClass:"fire",attrs:{"src":require("../../assets/ship-fire.png")}}),_vm._v(" "),_c('img',{staticClass:"body",attrs:{"src":require("../../assets/ship.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87bfd518","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/objects/Ship.vue
// module id = null
// module chunks = 